'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAvailableChartTypes = undefined;
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _constants = require('../constants');
var _dotstatsuiteSdmxjs = require('@sis-cc/dotstatsuite-sdmxjs');
var _getObservationsType = require('./getObservationsType');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
var getAvailableChartTypes = exports.getAvailableChartTypes = function getAvailableChartTypes(data) {
  var observationsType = (0, _getObservationsType.getObservationsType)(data);
  if (!R.includes(observationsType, [_constants.OBS_TYPE_NUMBER, _constants.OBS_TYPE_NUMERICAL_STRING])) {
    return {};
  }
  var dimensions = R.pathOr([], ['structure', 'dimensions', 'observation'], data);
  var timeDimension = (0, _dotstatsuiteSdmxjs.getTimePeriodDimension)({
    dimensions: dimensions
  });
  var refAreaDimension = (0, _dotstatsuiteSdmxjs.getRefAreaDimension)({
    dimensions: dimensions
  });
  var hasNoTime = R.anyPass([R.isNil, R.pipe(R.propOr([], 'values'), R.length, R.gte(1))])(timeDimension);
  return R.pipe(R.when(R.always(hasNoTime), R.omit([_constants.TIMELINE])), R.when(R.always(R.isNil(refAreaDimension)), R.omit([_constants.CHORO])))(_constants.TYPES);
};